var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-photo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.6 60.4444V21.5556C65.6 18.5 63.1 16 60.0444 16H21.1556C18.1 16 15.6 18.5 15.6 21.5556V60.4444C15.6 63.5 18.1 66 21.1556 66H60.0444C63.1 66 65.6 63.5 65.6 60.4444ZM30.8778 45.1667L37.8222 53.5278L47.5444 41L60.0444 57.6667H21.1556L30.8778 45.1667Z",
    fill: "#BDBDBD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvailable);
export default __webpack_public_path__ + "static/media/notAvailable.9654418e9b5c3fb784b4f86dd64200ed.svg";
export { ForwardRef as ReactComponent };